import React from 'react';
import { Typography, Collapse } from 'antd';
import { SafetyCertificateOutlined, ToolOutlined, CheckCircleOutlined } from '@ant-design/icons';
import '../assets/styles/About.css';

const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

const About = () => {
  return (
    <div className='background'>
<div className="about-page">
      <Title level={1} className="about-title fade-in">Sobre Nosotros</Title>
      <Paragraph className="about-description fade-in">
        Somos líderes en la industria de productos certificados para cañerías y sistemas de conducción. Con más de 30 años de experiencia, nos enorgullecemos de ofrecer soluciones de alta calidad y durabilidad para proyectos residenciales, comerciales e industriales.
      </Paragraph>
      
      <div className="about-features">
        <div className="feature-card slide-in-left">
          <SafetyCertificateOutlined className="feature-icon" />
          <Title level={3}>Productos Certificados</Title>
          <Paragraph>
            Todos nuestros productos cumplen con los más altos estándares de calidad y seguridad.
          </Paragraph>
        </div>
        <div className="feature-card slide-in-top">
          <ToolOutlined className="feature-icon" />
          <Title level={3}>Soluciones Integrales</Title>
          <Paragraph>
            Ofrecemos una amplia gama de productos para cubrir todas sus necesidades de conducción.
          </Paragraph>
        </div>
        <div className="feature-card slide-in-right">
          <CheckCircleOutlined className="feature-icon" />
          <Title level={3}>Garantía de Calidad</Title>
          <Paragraph>
            Respaldamos todos nuestros productos con garantías sólidas y servicio post-venta.
          </Paragraph>
        </div>
      </div>

      <Title level={2} className="section-title fade-in">Nuestra Historia</Title>
      <div className="timeline-container fade-in">
        <div className="timeline-item">
          <div className="timeline-content">
            <h3>1990</h3>
            <p>Fundación de la empresa</p>
          </div>
        </div>
        <div className="timeline-item">
          <div className="timeline-content">
            <h3>2000</h3>
            <p>Expansión a nivel nacional</p>
          </div>
        </div>
        <div className="timeline-item">
          <div className="timeline-content">
            <h3>2010</h3>
            <p>Certificación ISO 9001</p>
          </div>
        </div>
        <div className="timeline-item">
          <div className="timeline-content">
            <h3>2020</h3>
            <p>Lanzamiento</p>
          </div>
        </div>
      </div>

      <Title level={2} className="section-title fade-in">Nuestros Productos</Title>
      <Collapse className="products-collapse fade-in">
        <Panel header="Cañerías y Tuberías" key="1">
          <Paragraph>
            Ofrecemos una amplia gama de cañerías y tuberías para diferentes aplicaciones, incluyendo:
            <ul>
              <li>Tuberías de PVC</li>
              <li>Cañerías de cobre</li>
              <li>Tuberías de polietileno de alta densidad (PEAD)</li>
              <li>Cañerías de acero inoxidable</li>
            </ul>
          </Paragraph>
        </Panel>
        <Panel header="Accesorios y Conexiones" key="2">
          <Paragraph>
            Complementamos nuestra oferta de cañerías con una variedad de accesorios y conexiones:
            <ul>
              <li>Codos, tees y uniones</li>
              <li>Válvulas y llaves de paso</li>
              <li>Adaptadores y reductores</li>
              <li>Bridas y juntas</li>
            </ul>
          </Paragraph>
        </Panel>
        <Panel header="Sistemas de Conducción Especializados" key="3">
          <Paragraph>
            Para proyectos más específicos, contamos con sistemas especializados como:
            <ul>
              <li>Sistemas de conducción para gases medicinales</li>
              <li>Tuberías para la industria alimentaria</li>
              <li>Cañerías resistentes a productos químicos</li>
              <li>Sistemas de conducción para alta presión</li>
            </ul>
          </Paragraph>
        </Panel>
      </Collapse>

      <Title level={2} className="section-title fade-in">¿Por qué elegirnos?</Title>
      <div className="why-choose-us fade-in">
        <div className="reason-card">
          <Title level={4}>Experiencia y Conocimiento</Title>
          <Paragraph>
            Con más de tres décadas en el mercado, contamos con el expertise necesario para asesorar y proveer las mejores soluciones para su proyecto.
          </Paragraph>
        </div>
        <div className="reason-card">
          <Title level={4}>Innovación Constante</Title>
          <Paragraph>
            Invertimos continuamente en investigación y desarrollo para ofrecer productos de vanguardia que cumplen con las últimas normativas y tendencias del mercado.
          </Paragraph>
        </div>
      </div>

      <div className="cta-section fade-in">
        <Title level={2}>¿Listo para comenzar su proyecto?</Title>
        <Paragraph>
          Nuestro equipo de expertos está listo para asesorarlo y proporcionarle las mejores soluciones para sus necesidades.
        </Paragraph>
        <button onClick={() => window.location.href = '/contact'} className="cta-button">Contáctenos Ahora</button>
      </div>
    </div>
    </div>
    
  );
};

export default About;

